<template>
  <div :class="color" class="moles moles--form">
    <Mole class="moles__mole moles__mole--first" />
    <Mole class="moles__mole moles__mole--second" />
    <Mole class="moles__mole moles__mole--third" />
    <Mole class="moles__mole moles__mole--forth" />
  </div>
</template>

<script>
import Mole from '@/funnels/components/layout/Mole';

export default {
  props: {
    color: {
      type: String,
      default: 'moles--warning',
    },
  },
  components: { Mole },
};
</script>
